<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/E46BpE/tc-custom/9781597098328.jpg?1706683677055" alt="This image is the cover for the book Letters Written and Not Sent"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Letters Written and Not Sent
      </h1>
      <p class="bookDescription body article font2">
        <b>This culmination of a life of poetry, art, and social justice “has the freshness of an opening argument and the majesty of a man’s last words” (Molly Peacock, author of <i>The Analyst</i>).</b><br/><br/>Like paperweights, his lyrics are both small and hefty. His subjects range from race relations to trees, from secrets to parenthood, from ideas of god to kissing, from sons and mothers to fate, and of course, to poetry itself. Never afraid of the big questions of why human beings are alive, and what hope and justice are for, Louis-Dreyfus could take decades to finish a poem. A perfectionist, a thinker, and always inspired by visual art, he fought with himself over how to say what he wanted to say best. Like the French-Uruguayan businessman poet Jules Supervielle, whom Louis-Dreyfus translated, he felt the tug of the financial world against the pull of the lyricism of poetry, and the division marked his life and sparked ideas for his finest poems. As the heart condition that seized him made it absolutely imperative, finishing Letters Written and Not Sent literally became a life-or-death matter. This is the book that he wished to send into the world.<br/><br/><b>“There’s rock-bottom integrity, a dignified modesty, and a quizzical, persistent quest for meaning in this collection. It’s a final bequest to the living from an intensely generous man.” —</b><b>Rosanna Warren, author of <i>So Forth: Poems</i></b><br/><br/><b>“The poems of William Louis-Dreyfus testify to an inner life of great richness, but one that freely slipped across the border of the self into the world beyond . . . a fine collection of his work, and it is good to have it at last.” —</b><b>Charles Martin, author of <i>Future Perfect</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William Louis-Dreyfus
      </h2>
      
      <p class="authorDescription body article"><P>Culminating a lifetime passion for poetry, art and social justice, businessman William Louis-Dreyfus passed away just days after completing his only book of poems, <I>Letters Written and Not Sent</I>. &#160;Born in 1932 on the outskirts of Paris, Louis-Dreyfus came to the United States as a child, after France fell under German occupation. &#160;With undergraduate and law degrees from Duke University, he led the commodities-focused Louis-Dreyfus Group for over forty years. &#160;A New York City resident, he was President of The Poetry Society of America for a decade. &#160;Awarded an M.F.A. from Antioch University, his poems and translations appeared in <I>The New Criterion</I>, <I>Hudson Review</I>, <I>Southwest Review</I>, <I>Plume,</I><I>AGNI</I>, and <I>Boulevard</I>.&#160;</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Red Hen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?660667ca